import CollectionApi from 'client/api/v2/CollectionApi';

class CommandQueueApi extends CollectionApi {
  constructor() {
    super('/api/v2/queuedcommands', {
      skip: 0,
      limit: 10,
      sort: 'id',
      search: {
        fields: ['id'],
        searchTerm: '',
      },
    });
  }
}

export default new CommandQueueApi();
